import { skipToken } from "@reduxjs/toolkit/query";

import { CsComponent } from "api/memberPortal/cscomponent/cscomponent.types";
import { useGetCsComponentProjByPidQuery } from "api/memberPortal/cscomponent/cscomponentproj/cscomponentproj.api";
import { useGetEarsAndFilesByProductIdQuery } from "api/memberPortal/ear/ear.api";
import { EarWithFiles } from "api/memberPortal/ear/ear.types";
import { useGetFilesByTypeAndIdQuery } from "api/memberPortal/files/files.api";
import { UserUploadedFile } from "api/memberPortal/files/files.types";
import { useGetLabVendorsQuery } from "api/memberPortal/orgs/orgs.api";
import { OrgStub } from "api/memberPortal/orgs/orgs.types";
import { useGetAllProductEvaluatorsQuery } from "api/memberPortal/project/personnel/personnel.api";
import { ProjectPersonnel } from "api/memberPortal/project/personnel/personnel.types";
import { useGetProductQuery } from "api/memberPortal/project/product/product.api";
import { Product } from "api/memberPortal/project/product/product.types";
import { ProjectPp } from "api/memberPortal/project/protectionProfiles/protectionProfile.types";
import { useGetAllProjectPpByProductIdQuery } from "api/memberPortal/project/protectionProfiles/protectionProfiles.api";

const PRODUCT = {} as Product;
const PRODUCTFILES = [] as UserUploadedFile[];
const PRODUCTPPS = [] as ProjectPp[];
const EARDATA = [] as EarWithFiles[];
const CSCOMPONENTS = [] as CsComponent[];
const EVALUATORS = [] as ProjectPersonnel[];
const LABVENDORS = [] as OrgStub[];

export const useProductFormData = (product_id: number) => {
  const { data: product = PRODUCT, isFetching: isFetchingProduct } =
    useGetProductQuery(product_id ?? skipToken, {
      refetchOnMountOrArgChange: true,
    });

  const { data: productFiles = PRODUCTFILES, isFetching: isFetchingFiles } =
    useGetFilesByTypeAndIdQuery(
      {
        file_type: "product",
        file_type_id: product_id,
      },
      {
        skip: !product_id,
        refetchOnMountOrArgChange: true,
      },
    );

  const { data: productPps = PRODUCTPPS, isFetching: isFetchingProjectPps } =
    useGetAllProjectPpByProductIdQuery(product_id ?? skipToken, {
      refetchOnMountOrArgChange: true,
    });

  const { data: earData = EARDATA, isFetching: isFetchingEarsAndFiles } =
    useGetEarsAndFilesByProductIdQuery(product_id ?? skipToken, {
      refetchOnMountOrArgChange: true,
    });

  const {
    data: csComponents = CSCOMPONENTS,
    isFetching: isFetchingCsComponent,
  } = useGetCsComponentProjByPidQuery(product_id ?? skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const {
    data: evaluators = EVALUATORS,
    isFetching: isFetchingProductEvaluator,
  } = useGetAllProductEvaluatorsQuery(product_id ?? skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const { data: labVendors = LABVENDORS, isFetching: isFetchingLabVendors } =
    useGetLabVendorsQuery();

  const isLoading =
    isFetchingProduct ||
    isFetchingFiles ||
    isFetchingProjectPps ||
    isFetchingEarsAndFiles ||
    isFetchingCsComponent ||
    isFetchingProductEvaluator ||
    isFetchingLabVendors;

  return {
    product,
    productFiles,
    productPps,
    earData,
    csComponents,
    evaluators,
    labVendors,
    isLoading,
  };
};
